<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finDetail-fabricExpense',
  components: { PageTable },
}
</script>
